import React from 'react';
import DocumentsV2Compact from '../../../../components/DocUploadV2/DocumentsV2Compact';

const ProofOfDocumentCompactV2 = ({
    supportedFiles = ["image", "pdf"],
    single = false,
    enableOnline,
    seq,
    isAskForInfo,
    remark,
    recordId,
    asLabel,
    label,
    field,
    showCategory,
    ubo_id,
    type,
    formId,
    required = true,
    error = "",
    validateByAi = false,
    onValidationStatusChange = () => { },
    dataTestId,
}) => {
    return (
        <div className='docv2__wrap' data-testid={dataTestId}>
            <DocumentsV2Compact
                label={label}
                required={required}
                hint={isAskForInfo && remark ? remark : undefined}
                asLabel={asLabel}
                inline
                seq={seq}
                field={field}
                record_id={recordId}
                showCategory={showCategory}
                ubo_id={ubo_id}
                type={type}
                formId={formId}
                hideUpload
                enableOnline={enableOnline}
                supportedFiles={supportedFiles}
                single={single}
                error={error}
                validateByAi={validateByAi}
                onValidationStatusChange={onValidationStatusChange}
            />
        </div>
    );
};

export default ProofOfDocumentCompactV2;
